import { Directive } from '@angular/core';
import { NG_VALIDATORS, UntypedFormGroup, ValidationErrors, Validator } from '@angular/forms';
import { isMortgageTermValidMax, isMortgageTermValidMin } from '../../../helpers/format-helpers';
import { nullIfEmpty } from '../../../helpers/object-helpers';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[mortgageTermValidator]',
  // eslint-disable-next-line no-use-before-define
  providers: [{ provide: NG_VALIDATORS, useExisting: MortgageTermValidatorDirective, multi: true }],
})
export class MortgageTermValidatorDirective implements Validator {

  public validate(formGroup: UntypedFormGroup): ValidationErrors {
    const yearsControl = formGroup.controls['years'];
    const monthsControl = formGroup.controls['months'];

    if (!yearsControl || !monthsControl) {
      return null;
    }

    if (yearsControl.errors && !yearsControl.errors.mortgageTerm) {
      return null;
    }

    const validMax = !isMortgageTermValidMax(yearsControl.value, monthsControl.value);
    const validMin = !isMortgageTermValidMin(yearsControl.value, monthsControl.value);

    const errors = nullIfEmpty({
      ...(validMax && { loanTermMax: true }),
      ...(validMin && { loanTermMin: true }),
    });

    yearsControl.setErrors(errors);

    return errors;
  }
}
